import DisputeTransactionPage from "components/pages/DisputeTransactionPage";
import DisputeServiceReasonView from "components/pages/DisputeTransactionPage/components/DisputeServiceReasonView";

/**
 * @function DisputeServiceReasonPage
 * @param {OBJECT} data - Object to modify the data view.
 * @param {OBJECT} ui - Object to modify the ui of the view.
 * @return {React.Component}
 * @exported true
 * @description This page is a step in the dispute transactions workflow.
 * @example
 * <DisputeServiceReasonPage data={ data } ui={ ui } />
 */
export default function DisputeServiceReasonPage(props) {
    const data = props.data ? { data: props.data } : {};
    const ui = props.ui ? { ui: props.ui } : {};

    return (
        <DisputeTransactionPage 
        view={ <DisputeServiceReasonView { ...data } { ...ui } /> }
        />
    );
}